export const hubUrl = typeof window !== 'undefined' && ['127.0.0.1', 'localhost'].includes(window.location.hostname.toLowerCase())
  ? 'http://127.0.0.1:4170'
  : 'https://epos-hub.co.uk';
